import * as React from "react";

import { palletSelectorStore } from "./store/PalletSelectorStore";
import { PalletSelector } from "./PalletSelector";
import { Container } from "../Container";

interface IProps {
	isMovement?: boolean;
}

export const PalletSelectorWidget = (props: IProps): JSX.Element => (
	<Container store={palletSelectorStore}>
		<PalletSelector {...props}/>
	</Container>
);
